import { debounce } from 'lodash';

export const TOOLTIP_TRACKING_DEBOUNCE_TIME_MS = 3000;

export const debounceTooltipTracking = fn => {
    return debounce(fn, TOOLTIP_TRACKING_DEBOUNCE_TIME_MS, {
        leading: true,
        trailing: false,
    });
};
